import React from 'react';
import {connect} from 'react-redux';

import Bet from './Bet.jsx';

import {removeHistoryBets as removeHistoryBetsAction} from 'actions/creators/HistoryBet';

class BetHistory extends React.Component {
    static propTypes = {
        betHistory: React.PropTypes.object.isRequired,
        removeHistoryBetsAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
    }

    static renderBet(id) {
        return (<Bet key={id} id={id}/>);
    }

    render() {
        const betHistory = this.props.betHistory;

        if (betHistory === undefined || betHistory.size === 0) {
            return false;
        }

        const betIds = betHistory.keySeq().sortBy(x => parseInt(x)).reverse().toList();

        return (
            <div className="history-menu cf">
                <div className="body history-menu-body">
                    {betIds.map(BetHistory.renderBet)}
                </div>
            </div>
        );
    }
}

function select(state) {
    const betHistory = state.application.get('betHistory');
    const languageId = state.application.get('languageId');

    return {
        betHistory,
        languageId
    };
}

export default connect(select, {
    removeHistoryBetsAction
})(BetHistory);



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/bet-history/BetHistory.jsx